<template>
  <v-container
    id="mediaManager"
    class="mt-4 py-0"
  >
    <v-row>
      <v-toolbar>
        <v-toolbar-items>
          <v-btn
            icon
            :title="$t('mediacenter.back')"
            :disabled="previousDir.length <= 0"
            @click="back"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-btn
            icon
            :title="$t('mediacenter.home')"
            @click="home"
          >
            <v-icon>mdi-home</v-icon>
          </v-btn>
          <v-btn
            icon
            :title="$t('mediacenter.refresh')"
            @click="refresh()"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
          <v-divider
            class="mx-2"
            vertical
          />
          <dialog-line-edit
            icon="mdi-folder-plus"
            :title="$t('mediacenter.new-dir')"
            :placeholder="$t('mediacenter.name-dir')"
            :open-dialog="openNewDirDialog"
            :disabled="isShared"
            @ok-pushed="newDir"
            @cancel-pushed="closeNewDir"
          />
          <v-btn
            icon
            :title="$t('mediacenter.upload')"
            :disabled="isShared"
            @click="uploadShow = !uploadShow"
          >
            <v-icon>mdi-cloud-upload</v-icon>
          </v-btn>
          <v-btn
            icon
            :title="$t('mediacenter.download')"
            :href="getUrl()"
            :disabled="selected.mime == 'directory'"
            download
          >
            <v-icon>mdi-download</v-icon>
          </v-btn>
          <v-divider
            class="mx-2"
            vertical
          />
          <dialog-preview
            icon="mdi-eye"
            :title="$t('mediacenter.preview')"
            :disabled="
              !selected.mime.includes('image') && !selected.mime.includes('video') && !selected.mime.includes('zip')
            "
            :open-dialog="openPreviewDialog"
            :item="selected"
            @close="closePreview()"
          />
          <v-divider
            class="mx-2"
            vertical
          />
          <v-btn
            icon
            :title="$t('mediacenter.copy')"
            :disabled="selected.name === undefined"
            @click="copy"
          >
            <v-icon>mdi-content-copy</v-icon>
          </v-btn>
          <v-btn
            icon
            :title="$t('mediacenter.cut')"
            :disabled="selected.name === undefined || isScheduled || isShared || isLimited"
            @click="cut"
          >
            <v-icon>mdi-content-cut</v-icon>
          </v-btn>
          <v-btn
            icon
            :title="$t('mediacenter.paste')"
            :disabled="(!isCopy && !isCut) || isShared"
            :loading="pasteLoading"
            @click="paste"
          >
            <v-icon>mdi-content-paste</v-icon>
          </v-btn>
          <v-divider
            class="mx-2"
            vertical
          />
          <button-dialog-delete
            color=""
            :icon="true"
            :icon-only="true"
            icon-mdi="mdi-delete"
            :no-text="true"
            :text="textPopup"
            :title="$t('mediacenter.delete')"
            :open-dialog="openDeleteDialog"
            :is-button-disabled="selected.name === undefined || isScheduled || isShared || isLimited"
            :loading="deleteLoading"
            @ok-pushed="deleteSelect"
            @cancel-pushed="closeDelete"
          />
          <v-divider
            class="mx-2"
            vertical
          />
          <dialog-line-edit
            icon="mdi-form-textbox"
            :title="$t('mediacenter.rename')"
            :placeholder="placeholderRename"
            :disabled="selected.name === undefined || isScheduled || isShared || isLimited"
            :name-file="selected.name"
            :color="colorRename"
            :open-dialog="openRenameDialog"
            @ok-pushed="renameSelected"
            @cancel-pushed="closeRename"
          />
          <dialog-media-info
            icon="mdi-information-outline"
            :title="$t('mediacenter.info')"
            :disabled="selected.name === undefined || selected.mime == 'directory'"
            :item="selected"
          />
        </v-toolbar-items>
      </v-toolbar>
    </v-row>
    <v-row>
      <v-col
        class="col_dirExplorer"
        cols="3"
        wrap
        xs3
      >
        <dir-explorer
          ref="dirExplorer"
          :root-dir="mediacenterPath"
          :current-item="explorerSelection"
          :share-access="true"
          @item-selected="dirSelected"
          @paste-to-dir="pasteDir"
          @rename-dir="openRenameDir"
          @delete-dir="openDeleteDir"
        />
      </v-col>
      <v-col
        class="col_dirContent"
        cols="9"
        wrap
        xs9
        @contextmenu.prevent="showVoidContext"
      >
        <v-container
          grid-list-md
          justify-start
          fluid
          @keydown.8="back"
          @keydown.ctrl.a.prevent="selectAll"
          @keydown.ctrl.67="copy"
          @keydown.ctrl.88="cut"
          @keydown.ctrl.86="paste"
          @keydown.46="openDelete"
          @keydown.ctrl.78="openNewDir"
          @keydown.113="openRename"
          @keydown.ctrl="onCtrlDown"
          @keydown.shift="onShiftDown"
          @keyup="onKeyUp"
        >
          <v-layout
            v-show="uploadShow"
            row
            wrap
          >
            <file-upload :current-directory="explorerSelection" />
          </v-layout>
          <v-layout
            v-show="!uploadShow"
            row
            wrap
            @keydown.ctrl.86="paste"
          >
            <template v-for="item in items">
              <media-manager-item
                :ref="'managerItem' + item.id"
                :key="item.path"
                :object="item"
                :class="{ selected: item.path == selected.path }"
                :set-dragged-item="setDraggedItem"
                :end-drag="endDrag"
                :selected-items="selectedItems"
                @click="itemClicked"
                @dblclick="viewFile"
                @contextMenu="showItemContext"
              />
            </template>
          </v-layout>
        </v-container>
      </v-col>
    </v-row>
    <context-menu
      :items="contextItems"
      :position="contextPos"
      :show="contextShow"
      :selected-item="selected"
      @action="contextAction"
    />
  </v-container>
</template>

<script>
// Components
import buttonDialogDelete from "../Common/ButtonDialogDelete";
import dirExplorer from "../Common/DirExplorer";
import mediaManagerItem from "./MediaManagerItem";
import dialogLineEdit from "../Dialog/DialogLineEdit";
import dialogPreview from "../Dialog/DialogPreview";
import dialogMediaInfo from "../Dialog/DialogMediaInfo";
import fileUpload from "../Common/FileUpload";
import contextMenu from "../Common/ContextMenu";

// Connectors
import { ProjectConnector } from "../Database/ProjectConnector.js";
import { ScheduleConnector } from "../Database/ScheduleConnector";
import { ProfileUserConnector } from "../Database/ProfileUserConnector";

// Tools
const ft = require("../Tools/FileTools");
const pathInfo = require("path");

export default {
  components: {
    dirExplorer,
    mediaManagerItem,
    dialogLineEdit,
    dialogPreview,
    buttonDialogDelete,
    dialogMediaInfo,
    fileUpload,
    contextMenu,
  },
  data() {
    return {
      projectConnector: new ProjectConnector(this.$store.state.user),
      scheduleConnector: new ScheduleConnector(this.$store.state.user),
      profileUserConnector: new ProfileUserConnector(this.$store.state.user),
      mediacenterPath: "",
      explorerSelection: [],
      previousDir: [],
      items: [],
      selected: { name: undefined, mime: "directory" },
      selectedItem: { name: undefined, mime: "directory" },
      selectedItems: [],
      selectedItemsToTask: [],
      srcPath: "",
      isCut: false,
      isCopy: false,
      uploadShow: false,
      textPopup: this.$t("popup.file"),
      projectPlan: [],
      limitedDirectories: [],
      colorRename: "",
      placeholderRename: this.$t("mediacenter.new-name"),
      preventHistory: false,
      openDeleteDialog: false,
      openNewDirDialog: false,
      openPreviewDialog: false,
      openRenameDialog: false,
      contextItems: [],
      contextPos: {
        x: 0,
        y: 0,
      },
      contextShow: false,
      draggedItem: null,
      ctrlPressed: false,
      shiftPressed: false,
      pasteLoading: false,
      deleteLoading: false,
    };
  },
  computed: {
    isLimited() {
      // CHECK IF THE DIRECTORY IS LIMITED FOR A USER OR NOT
      if (this.selected.mime === "directory" && this.limitedDirectories.length > 0) {
        if (JSON.stringify(this.limitedDirectories).match(this.selected.path)) {
          return true;
        }
      }

      return false;
    },
    isScheduled() {
      // CHECK IF THE FILE IS SCHEDULED OR NOT
      let scheduled = false;

      // IF OBJECT CONTAINS PROPERTY ASSIGN IT
      if (this.selected.scheduled !== undefined) {
        scheduled = this.selected.scheduled;
      }

      return scheduled;
    },
    isShared() {
      // CHECK IF THE CURRENT DIR IS SHARED
      let shared = false;

      // IF OBJECT CONTAINS SOMETHING CHECK IF IT INCLUDES "SHARE"
      if (this.explorerSelection.length > 0) {
        if (this.explorerSelection[0].includes("mediacenter/share")) {
          shared = true;
        }
      }

      return shared;
    },
  },
  watch: {
    uploadShow: function (isShow) {
      if (!isShow) {
        this.refresh();
      }
    },
  },
  created() {
    this.mediacenterPath = this.$store.state.config.dirs.app + "mediacenter/" + this.$store.state.user.socId;

    // If dir limited for user we use this root path
    if (this.$store.state.user.dir != "") {
      this.mediacenterPath = this.$store.state.user.dir;
    }

    this.explorerSelection = [this.mediacenterPath];

    if (this.$store.state.user.socId != null) {
      // API CALLS
      this.getAllProjectPlan();
      this.checkLimitedDirectories();
    }
  },
  mounted() {
    if (this.$store.state.user.socId != null) {
      this.refresh();
    }
    //Ajout d'un listener sur la touche Echap pour track la fermeture de dialogue
    document.addEventListener("keydown", this.onEscapeInput);
  },
  methods: {
    onCtrlDown() {
      this.ctrlPressed = true;
    },
    onShiftDown() {
      this.shiftPressed = true;
    },
    onKeyUp() {
      this.ctrlPressed = false;
      this.shiftPressed = false;
    },
    closePreview() {
      this.openPreviewDialog = false;
    },
    getAllProjectPlan() {
      this.scheduleConnector
        .getAllProjectPlan()
        .then((response) => {
          this.projectPlan = response;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    checkLimitedDirectories() {
      this.profileUserConnector
        .checkLimitedDirectories()
        .then((response) => {
          if (response.length > 0) {
            this.limitedDirectories = response;
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    viewFile() {
      if (this.selected.mime.includes("image") || this.selected.mime.includes("video")) {
        this.openPreviewDialog = true;
      } else if (this.selected.type == "dir") {
        this.preventHistory = true;
        this.previousDir.push(this.explorerSelection[0]);
        this.explorerSelection = [this.selected.path];
      } else if (this.selected.mime.includes("zip")) {
        this.loadProject();
      }
    },
    loadProject() {
      const path = this.selected.path.replace(".\\", "").replace("./", "").split("\\").join("/");
      this.projectConnector
        .getInfoWithPath(path)
        .then((pid) => {
          if (pid) {
            const projectData = {
              projId: pid,
              projectName: this.selected.name,
              savePath: path,
            };

            this.$store.dispatch("open", projectData).project;
            this.$router.push({ path: "/project/1" });
          }
        })
        .catch((err) => {
          // Maybe the project is imported from elsewhere (shared to user dir for example)
          console.error(err);

          // Try to open project simply by its name + path
          const projectData = {
            projectName: this.selected.name,
            savePath: path,
          };

          this.$store.dispatch("open", projectData).project;
          this.$router.push({ path: "/project/1" });
        });
    },
    sortItems() {
      // Sort first dirs and files after
      this.items = this.items.sort(function (a, b) {
        if (a.type == "dir" && b.type == "file") {
          return -1;
        }
        if (a.type == "file" && b.type == "dir") {
          return 1;
        }
      });
    },
    changeDir(dirPath) {
      if (!this.preventHistory) {
        if (this.previousDir.length > 0) {
          const rootPath = this.$store.state.config.dirs.root;
          const appPath = this.$store.state.config.dirs.app;
          // Prevent add two times the same dir
          if (
            this.explorerSelection[0].replace(appPath, rootPath) !=
            this.previousDir.slice(-1).pop().replace(appPath, rootPath)
          ) {
            this.previousDir.push(this.explorerSelection[0]);

            if (this.previousDir.length > 30) {
              this.previousDir = this.previousDir.slice(-30);
            }
          }
        } else {
          this.previousDir.push(this.explorerSelection[0]);
        }
      }

      this.preventHistory = false;

      // Set current dir for direxplorer component to select it
      this.explorerSelection = dirPath;

      ft.scanFlat(this.explorerSelection[0], []).then((response) => {
        this.items = response;
        this.itemPlan();
        this.sortItems();

        // Reset selected data to disable tool buttons
        this.deselect();
      });
    },
    dirSelected(val) {
      if (val.length > 0) {
        this.changeDir(val);
      }
    },
    itemClicked(obj) {
      if (this.ctrlPressed && this.selected.name != null) {
        let filter = this.selectedItems.filter((item) => item.id == obj.id);

        if (filter.length == 0) {
          if (this.selectedItems.length == 0) {
            this.selectedItems.push(this.selected);
          }
          this.selectedItems.push(obj);
        } else {
          this.selectedItems = this.selectedItems.filter((item) => item.id != obj.id);
        }
      } else if (this.shiftPressed && this.selected.name != null) {
        let pA = this.getPosThisItem(this.selected);
        let pB = this.getPosThisItem(obj);
        let p1 = pA < pB ? pA : pB;
        let p2 = pA < pB ? pB : pA;
        this.selectedItems = [];
        this.items.forEach((item, i) => {
          if (i >= p1 && i <= p2) {
            this.selectedItems.push(item);
          }
        });
      } else {
        this.selected = obj;
        this.selectedItems = [];
      }
    },
    refresh() {
      this.preventHistory = true;
      this.changeDir(this.explorerSelection);
    },
    back() {
      if (this.previousDir.length > 0) {
        this.preventHistory = true;
        this.explorerSelection = [this.previousDir.pop()];
      }
    },
    home() {
      this.preventHistory = true;
      this.previousDir.push(this.explorerSelection[0]);
      this.explorerSelection = [this.mediacenterPath];
    },
    newDir(val) {
      if (this.explorerSelection.length > 0) {
        if (!this.isShared) {
          let dirName = val;
          // remove trailing spaces and points beginning and end of name
          dirName = dirName.trim().replace(/^\.+|\.+$/g, "");

          const newDir = this.explorerSelection[0] + "/" + dirName;

          ft.createDir(newDir)
            .then(() => {
              this.$refs.dirExplorer.refresh();
              this.refresh();
            })
            .catch((err) => {
              console.error(err);
            });
          // Close dialog to reset ContextMenu
          this.openNewDirDialog = false;
        }
      }
    },
    copy() {
      if (this.explorerSelection.length > 0) {
        this.srcPath = this.selected.path;
        this.selectedItem = this.selected;
        this.isCopy = true;
        this.isCut = false;
        if (this.selectedItems.length > 0) {
          this.selectedItemsToTask = this.selectedItems;
        }
      } else {
        this.isCopy = false;
        this.isCut = false;
      }
    },
    cut() {
      if (this.isScheduled) {
        this.$store.dispatch("openSnackbar", {
          title: this.$t("dialog.warning"),
          txt: this.$t("popup.project-scheduled"),
          colorBg: "orange",
        });
        return;
      }
      if (this.isLimited) {
        // Show warning message saying directory limited
        this.$store.dispatch("openSnackbar", {
          title: this.$t("dialog.warning"),
          txt: this.$t("popup.directory-limited"),
          colorBg: "orange",
        });
      } else {
        if (!this.isShared) {
          if (this.explorerSelection.length > 0) {
            this.srcPath = this.selected.path;
            this.selectedItem = this.selected;
            this.isCopy = false;
            this.isCut = true;
            if (this.selectedItems.length > 0) {
              this.selectedItemsToTask = this.selectedItems;
            }
          } else {
            this.isCopy = false;
            this.isCut = false;
          }
        }
      }
    },
    pasteDir(path) {
      this.selected = {
        mime: "directory",
        name: pathInfo.basename(path),
        path: path,
        type: "dir",
      };

      // Call to paste function
      this.paste();
    },
    paste() {
      if ((this.isCopy || this.isCut) && !this.isShared) {
        if (this.explorerSelection.length > 0) {
          if (!this.isShared) {
            //coller un seul fichier
            if (this.selectedItemsToTask.length == 0) {
              this.pasteLoading = true;
              this.pasteOnefile(this.selectedItem);
            } else {
              //coller plusieurs fichiers (multiselection)
              this.pasteLoading = true;
              this.selectedItemsToTask.forEach((file, n) => {
                setTimeout(() => {
                  this.pasteOnefile(file, n, this.selectedItemsToTask.length - 1);
                }, n * 100);
              });
            }
          }
        }
      }
    },
    pasteOnefile(file, n = 1, nMax = 1) {
      //si un dossier est sélectionné (ou click droit)
      const destPath =
        this.selected.type == "dir" && this.selected.path != null
          ? this.selected.path //colle dans ce dossier
          : this.explorerSelection[0]; //sinon colle dans le dossier courant

      let newPath = "";
      // Vérification si un dossier est sélectionné pour le cibler directement sans avoir à s'y rendre
      // if(file.type == "dir" && file.path != null) {
      //   let formattedPath = destPath //file.path;
      //   if(!formattedPath.includes(this.$store.state.config.dirs.app)) {
      //     formattedPath = formattedPath.replace(this.$store.state.config.dirs.root, this.$store.state.config.dirs.app);
      //   }
      //   newPath = formattedPath + "/" + pathInfo.basename(file.path);
      // }
      // else {
      newPath = destPath + "/" + pathInfo.basename(file.path);
      // }

      if (this.isCopy) {
        ft.copy(file.path, newPath)
          .then(() => {
            if (n == nMax) {
              //attend que tous les fichier soient copiés
              this.endCopyAndCut();
            }
          })
          .catch((err) => {
            this.endCopyAndCut();
            console.error(err);
          });
      } else if (this.isCut) {
        ft.cut(file.path, newPath)
          .then(() => {
            if (n == nMax) {
              //attend que tous les fichier soient copiés
              this.endCopyAndCut();
            }
          })
          .catch((err) => {
            this.endCopyAndCut();
            console.error(err);
          });
      }
    },
    endCopyAndCut() {
      this.pasteLoading = false;
      this.isCopy = false;
      this.isCut = false;
      this.srcPath = "";
      this.selectedItemsToTask = [];
      this.$refs.dirExplorer.refresh();
      this.refresh();
    },
    deleteSelect() {
      if (!this.isShared) {
        if (!this.isScheduled) {
          this.deleteLoading = true;
          if (this.selectedItems.length == 0) {
            this.deleteOneFile(this.selected);
          } else {
            this.selectedItems.forEach((file, n) => {
              this.deleteOneFile(file, n, this.selectedItems.length - 1);
            });
          }
        } else {
          this.$store.dispatch("openSnackbar", {
            title: this.$t("dialog.warning"),
            txt: this.$t("popup.project-scheduled"),
            colorBg: "orange",
          });
        }
      }
    },
    deleteOneFile(file, n = 1, nMax = 1) {
      ft.remove(file.path)
        .then(() => {
          if (pathInfo.extname(file.path) == ".zip") {
            const path = file.path.split("\\").join("/").replace("./", "");
            this.projectConnector.deleteProjectWithPath(path);
          }

          if (file.mime == "directory") {
            this.$refs.dirExplorer.refresh();
            this.$refs.dirExplorer.itemSelected([this.$refs.dirExplorer.rootPath]);
          }
          if (n == nMax) {
            this.deleteLoading = false;
            this.refresh();
          }
        })
        .catch((err) => {
          console.error(err);
          this.deleteLoading = false;
        })
        .finally(() => {
          this.openDeleteDialog = false;
        });
    },
    renameSelected(val) {
      if (!this.isShared || !this.isLimited) {
        this.openRenameDialog = false;
        let isDuplicate = false;
        let newName = val;

        // remove trailing spaces and points beginning and end of name
        newName = newName.trim().replace(/^\.+|\.+$/g, "");

        this.items.forEach((element) => {
          if (this.selected.mime == element.mime) {
            if (newName == element.name) {
              isDuplicate = true;
            }
          }
        });

        if (!isDuplicate) {
          if (this.selected.mime == "directory") {
            newName = newName.replace(/\/|\\/g, "");
            this.projectConnector.updateProjectPathFolder(this.selected.path, newName);
          }
          if (this.selected.mime.includes("zip")) {
            const path = this.selected.path.split("\\").join("/").replace("./", "");
            this.projectConnector
              .getInfoWithPath(path)
              .then((pid) => {
                // TODO: rename project in db, if exist update, if not insert
                if (pid) {
                  const projId = pid;
                  const pathNew = this.selected.path
                    .replace(this.selected.name, newName)
                    .split("\\")
                    .join("/")
                    .replace("./", "");
                  this.projectConnector.putRename(projId, pathNew);
                }
              })
              .catch((err) => {
                console.error(err);
              });
          }

          ft.rename(this.selected.path, newName)
            .then(() => {
              if (this.selected.mime == "directory") {
                this.$refs.dirExplorer.refresh();
              }

              this.refresh();
              this.deselect();
            })
            .catch((err) => {
              console.error(err);
            });

          this.colorRename = "";
          this.placeholderRename = this.$t("mediacenter.new-name");
        } else {
          this.$nextTick(() => {
            this.nameDuplicated();
          });
        }
      }
    },
    nameDuplicated() {
      this.openRenameDialog = true;
      this.colorRename = "red";
      this.placeholderRename = this.$t("mediacenter.name-use");
    },
    openRenameDir(path) {
      this.selected = {
        mime: "directory",
        name: pathInfo.basename(path),
        path: path,
        type: "dir",
      };

      // Open rename dialog
      this.openRename();
    },
    openRename() {
      if (this.isScheduled) {
        // Show warning message saying project scheduled
        this.$store.dispatch("openSnackbar", {
          title: this.$t("dialog.warning"),
          txt: this.$t("popup.project-scheduled"),
          colorBg: "orange",
        });
      } else if (this.isLimited) {
        // Show warning message saying directory limited
        this.$store.dispatch("openSnackbar", {
          title: this.$t("dialog.warning"),
          txt: this.$t("popup.directory-limited"),
          colorBg: "orange",
        });
      } else {
        this.openRenameDialog = true;
      }
    },
    closeRename() {
      this.openRenameDialog = false;
    },
    openDeleteDir(path) {
      this.selected = {
        mime: "directory",
        name: pathInfo.basename(path),
        path: path,
        type: "dir",
      };

      // Open delete dialog
      this.openDelete();
    },
    openDelete() {
      if (this.isScheduled) {
        // Show warning message saying project scheduled
        this.$store.dispatch("openSnackbar", {
          title: this.$t("dialog.warning"),
          txt: this.$t("popup.project-scheduled"),
          colorBg: "orange",
        });
      } else if (this.isLimited) {
        // Show warning message saying directory limited for a user

        this.$store.dispatch("openSnackbar", {
          title: this.$t("dialog.warning"),
          txt: this.$t("popup.directory-limited"),
          colorBg: "orange",
        });
      } else {
        this.openDeleteDialog = true;
      }
    },
    closeDelete() {
      this.openDeleteDialog = false;
    },
    openNewDir() {
      this.openNewDirDialog = true;
    },
    closeNewDir() {
      this.openNewDirDialog = false;
    },
    deselect() {
      this.selected = { name: undefined, type: "dir", mime: "directory" };
      this.selectedItems = [];
    },
    itemPlan() {
      this.items.forEach((element) => {
        if (element.ext == ".zip") {
          element.scheduled = this.addBadgeScheduled(element.path);
        }
      });
    },
    addBadgeScheduled(path) {
      // If project plan contains the project we return true
      return this.projectPlan.includes(path.replace("./", ""));
    },
    getUrl() {
      if (this.selected.mime !== "directory" && this.selected.mime !== "none") {
        return this.selected.path.split("\\").join("/");
      }
    },
    getPosItem() {
      let pos;
      this.items.forEach((item, i) => {
        if (item.id === this.selected.id) {
          pos = i;
        }
      });
      return pos;
    },
    getPosThisItem(thisItem) {
      let pos;
      this.items.forEach((item, i) => {
        if (item.id === thisItem.id) {
          pos = i;
        }
      });
      return pos;
    },
    controlItem(item, pos) {
      if (item == undefined) {
        if (this.selected.name == undefined) {
          pos = 0;
        }
        return this.items[pos];
      }
      return item;
    },
    setDraggedItem(itemFrom) {
      this.draggedItem = itemFrom;
    },
    endDrag(itemTo) {
      //on ne peut pas déplacer un fichier/dossier ailleurs que dans un dossier
      //on ne peut pas déplacer un dossier dans lui-même
      if (itemTo.type != "dir" || this.draggedItem.path == itemTo.path) {
        return;
      }

      if (this.selectedItems.length == 0) {
        this.dragOneFile(this.draggedItem, itemTo);
      } else {
        this.selectedItems.forEach((file) => {
          this.dragOneFile(file, itemTo);
        });
      }
      this.$refs["managerItem" + itemTo.id][0].onDragLeave();
    },
    dragOneFile(draggedItem, itemTo) {
      let filepath = draggedItem.path;
      let newpath = itemTo.path + "/" + pathInfo.basename(draggedItem.path);
      ft.cut(filepath, newpath)
        .then(() => {
          this.$refs.dirExplorer.refresh();
          this.refresh();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    selectAll() {
      this.selectedItems = this.items;
    },
    contextAction(item) {
      switch (item.action) {
        case "preview":
          this.viewFile();
          break;
        case "copy":
          this.copy();
          break;
        case "cut":
          this.cut();
          break;
        case "paste":
          this.paste();
          break;
        case "rename":
          this.openRename();
          break;
        case "upload":
          this.uploadShow = true;
          break;
        case "newdir":
          this.openNewDir();
          break;
        case "delete":
          this.openDelete();
          break;
        default:
          break;
      }
    },
    makeFileContext() {
      this.contextItems = [
        {
          icon: "mdi-open-in-new",
          label: this.$t("project.open"),
          action: "preview",
        },
        {
          action: "divider",
        },
        {
          icon: "mdi-content-copy",
          label: this.$t("mediacenter.copy"),
          action: "copy",
        },
        {
          icon: "mdi-content-cut",
          label: this.$t("mediacenter.cut"),
          action: "cut",
        },
        {
          icon: "mdi-content-paste",
          label: this.$t("mediacenter.paste"),
          action: "paste",
        },
        {
          action: "divider",
        },
        {
          icon: "mdi-form-textbox",
          label: this.$t("mediacenter.rename"),
          action: "rename",
        },
        {
          icon: "mdi-delete",
          label: this.$t("mediacenter.delete"),
          action: "delete",
        },
      ];
    },
    makeVoidContext() {
      this.contextItems = [
        {
          icon: "mdi-folder-plus",
          label: this.$t("mediacenter.new-dir"),
          action: "newdir",
        },
        {
          icon: "mdi-cloud-upload",
          label: this.$t("mediacenter.upload"),
          action: "upload",
        },
        {
          action: "divider",
        },
        {
          icon: "mdi-content-paste",
          label: this.$t("mediacenter.paste"),
          action: "paste",
        },
      ];
    },
    showContext(event) {
      event.stopPropagation();
      this.contextShow = false;

      this.$nextTick(() => {
        this.contextPos = {
          x: event.x,
          y: event.y,
        };

        this.contextShow = true;
      });
    },
    showItemContext(event) {
      this.makeFileContext();
      this.showContext(event);
    },
    showVoidContext(event) {
      this.makeVoidContext();
      this.showContext(event);
    },

    //Méthode associé au listener dans created()
    onEscapeInput(event) {
      switch (event.key === "Escape") {
        case this.openPreviewDialog:
          this.closePreview();
          break;
        case this.openDeleteDialog:
          this.closeDelete();
          break;
        case this.openNewDirDialog:
          this.closeNewDir();
          break;
        case this.openRenameDialog:
          this.closeRename();
          break;

        default:
          break;
      }
    },
  },
};
</script>

<style>
.theme--dark #mediaManager {
  background-color: #282828;
}

.theme--light #mediaManager {
  background-color: #efefef;
}

.theme--dark #mediaManager .col_dirExplorer {
  border-right: 1px solid rgba(255, 255, 255, 0.12);
}

.theme--light #mediaManager .col_dirExplorer {
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}

#mediaManager #direxplorer {
  overflow-y: auto;
  height: calc(85vh - 150px - 36px);
}

#mediaManager .col_dirContent {
  height: calc(85vh - 150px);
  overflow-y: auto;
}
</style>
